module.exports = __webpack_public_path__ + "img/base-blackwoman.00df9003.svg";